declare global {
  interface Window {
    gtag?: (
      command: 'config' | 'event' | 'js',
      targetId: string | Date,
      config?: {
        page_path?: string;
        [key: string]: any;
      }
    ) => void;
    dataLayer?: any[];
  }
}

export const GA4_MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID;
export const GOOGLE_ADS_ID = import.meta.env.VITE_GOOGLE_ADS_ID;

export const initGA = () => {
  // GA is already initialized in index.html, this is just a safety check
  if (!GA4_MEASUREMENT_ID) {
    console.warn('GA4_MEASUREMENT_ID not configured');
    return;
  }

  // Initialize dataLayer if it doesn't exist (should already exist from index.html)
  window.dataLayer = window.dataLayer || [];
  
  // Define gtag function if it doesn't exist (should already exist from index.html)
  if (!window.gtag) {
    window.gtag = function() {
      window.dataLayer?.push(arguments);
    };
  }

  // GA4 is already configured in index.html, so we don't need to reconfigure it here
  console.log('GA4 initialized with ID:', GA4_MEASUREMENT_ID);
};

export const trackPageview = (path: string) => {
  if (typeof window.gtag !== 'function') {
    return;
  }

  // Send page view to GA4
  if (GA4_MEASUREMENT_ID) {
    window.gtag('config', GA4_MEASUREMENT_ID, {
      page_path: path,
    });
  }

  // Send page view to Google Ads
  if (GOOGLE_ADS_ID) {
    window.gtag('config', GOOGLE_ADS_ID, {
      page_path: path,
    });
  }

  // Debug logging in development
  if (import.meta.env.DEV) {
    console.log('Tracked page view:', { path, GA4_MEASUREMENT_ID, GOOGLE_ADS_ID });
  }
};

export const trackEvent = (eventName: string, parameters?: { [key: string]: any }) => {
  if (typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', eventName, parameters);

  // Debug logging in development
  if (import.meta.env.DEV) {
    console.log('Tracked event:', { eventName, parameters });
  }
};

export const trackAdsConversion = (conversionId: string, conversionLabel?: string, value?: number, currency: string = 'USD') => {
  if (!GOOGLE_ADS_ID || typeof window.gtag !== 'function') {
    return;
  }

  const conversionData: any = {
    send_to: `${GOOGLE_ADS_ID}/${conversionLabel || conversionId}`,
  };

  if (value !== undefined) {
    conversionData.value = value;
    conversionData.currency = currency;
  }

  window.gtag('event', 'conversion', conversionData);

  // Debug logging in development
  if (import.meta.env.DEV) {
    console.log('Tracked ads conversion:', { conversionId, conversionLabel, value, currency });
  }
};